import { CorporateClientState } from '../corporate-client.state';
import * as corporateClient from '../actions/coprorate-client.actions';

const initialState: CorporateClientState = {
    corporateClientId: null,
    corporateClientName: null,
    allowedToOrder: false,
    financiallyActive: false,
    showPrices: false,
};

export const corporateClientReducer = (state: CorporateClientState = initialState,
                                action) => {
    switch (action.type) {
        case corporateClient.ActionTypes.CORPORATE_CLIENT_UPDATE:
            return {...state, ...action.payload};
        default:
            return state;
    }
};
